module.exports = __webpack_public_path__ + "img/logo.8b1d9815.png";